<template>
    <div class="row">
        <div class="col col-12 col-section-header">
            <div :id="label.toLowerCase()" class="section-anchor"></div>
            <div class="lore-section-header" :class="{ 'lore-section-header--less-bottom': lessBottom }">
                <div class="lore-section-label">{{ label }}</div>
                <div class="lore-section-text" v-html="header"></div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "LoreSectionHeader",
    props: {
      label: {
        type: String,
        required: true
      },
      header: {
        type: String,
        required: true
      },
      lessBottom: {
        type: Boolean,
        default: false
      }
    }
  };
  </script>
  
  <style scoped>
  .lore-section-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: center;
    margin-top: 16rem;
    margin-bottom: 8rem;
    width: 100%;
  }

  .section-anchor {
    position: absolute;
    top: -80px; /* Adjust this value based on your nav height + desired offset */
    visibility: hidden;
    }

  .lore-section-header--less-bottom {
    margin-bottom: 4rem;
  }
  
  /* Top text styling */
  .lore-section-label {
    font-size: 3.2rem;
    line-height: 1;              /* 100% line height */
    letter-spacing: -0.05em;      /* approx -5% letter spacing */
    font-weight: 500;            /* medium weight */
    color: #7e7e7e;
    font-family: "Untitled Sans", sans-serif;
    margin-bottom: 1.6rem;       /* spacing between texts */
    width: 100%;
  }
  
  /* Bottom text styling */
  .lore-section-text {
    font-size: 7.2rem;
    line-height: 1.2;            /* 120% line height */
    letter-spacing: -0.05em;      /* approx -5% letter spacing */
    font-weight: 400;            /* regular weight */
    color: #ededed;
    font-family: "Untitled Serif", serif;
    width: 100%;
  }

  .col-section-header {
    position: relative;
  }

  @media (max-width: 768px) {
    .lore-section-text {
      font-size: 4.2rem;
      line-height: 1.2; 
    }

    .lore-section-label {
        font-size: 2.2rem;
        line-height: 1;
    }

    .lore-section-header {
        margin-top: 8rem;
        margin-bottom: 4rem;
    }
  }
  </style>
  